import { Pipe, PipeTransform } from "@angular/core";
import { DocumentModel } from "../../../ek-e-commerce/ek-models/document.model";
@Pipe({ name: "filterUrlByTitle" })
export class FilterUrlTitlePipe implements PipeTransform {
  transform(value: DocumentModel[], documentTitle: string): string {
    const skeleton = "assets/icons/svgs/backup.svg";
    if (!value) {
      return "";
    }
    const document = value.find(
      (document: DocumentModel) =>
        document.documentsTitle === documentTitle && document.documentUrl,
    );
    return document?.id ? document?.documentUrl || skeleton : "";
  }
}
